
/**
 * Componente responsável por exibir informações e ações relacionadas a um produto do tipo assinatura.
 * 
 * @remarks
 * Este componente exibe detalhes do produto, permite a compra direta e oferece a funcionalidade de compra com um clique.
 * Também lida com a exibição de opções adicionais e adapta o comportamento para dispositivos móveis.
 * 
 * @example
 * ```html
 * <pme-product-assinatura
 *   [productData]="produto"
 *   [elementIndex]="indice"
 *   [shopWindowReduced]="janelaReduzida"
 *   (buyClicked)="aoComprar()"
 *   (clickOneClickPurchase)="aoComprarComUmClique($event)"
 * ></pme-product-assinatura>
 * ```
 * 
 * @input productData Dados do produto a ser exibido.
 * @input oneClickPurchaseInfo Informações para compra com um clique.
 * @input elementIndex Índice do elemento na lista.
 * @input shopWindowReduced Indica se a vitrine está em modo reduzido.
 * @input idOneClick Identificador da compra com um clique.
 * 
 * @output buyClicked Evento emitido ao clicar no botão de compra.
 * @output clickOneClickPurchase Evento emitido ao acionar a compra com um clique.
 * @output calculate Evento emitido para solicitar o cálculo de valores.
 * 
 * @property isMobile Indica se o usuário está em um dispositivo móvel.
 * @property showOneClick Controla a exibição da opção de compra com um clique.
 * @property dropdownOpened Controla a abertura do dropdown de opções.
 * 
 * @method onBuyClicked Emite o evento de compra.
 * @method formatCurrency Formata valores monetários para o padrão brasileiro.
 * @method onHover Exibe a opção de compra com um clique ao passar o mouse.
 * @method onLeave Oculta a opção de compra com um clique ao sair com o mouse.
 * @method onClickOneClickPurchase Emite o evento de compra com um clique.
 * @method onDropClicked Alterna a abertura do dropdown.
 * @method onClick Alterna a exibição da opção de compra com um clique em dispositivos móveis.
 * @method checkShowOneClick Verifica se a opção de compra com um clique deve ser exibida.
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OneClickPurchaseInfo } from '../../model/one-click-purchase-info';
import { ShopWindowItem } from '../../model/shop-window-item';

@Component({
    selector: 'pme-product-assinatura',
    templateUrl: './product-assinatura.component.html',
    styleUrls: ['./product-assinatura.component.scss'],
    standalone: false
})
export class ProductAssinaturaComponent implements OnInit {

  @Input() productData: ShopWindowItem;
  @Input() showDetail: boolean;

  @Output() buyClicked = new EventEmitter<void>();

  isMobile = /mobile|android|iphone|ipad|ipod|blackberry|windows phone/.test(navigator.userAgent.toLowerCase());


  showOneClick: boolean = false;
  dropdownOpened: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  onBuyClicked(): void {
    this.buyClicked.emit();
  }

  formatCurrency(value: number) {
    let valueString = value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    if (valueString.endsWith(",00")) {
      valueString = valueString.slice(0, -3);
    }

    return valueString;
  }

  onDropClicked(): void {
    this.dropdownOpened = !this.dropdownOpened;
  }

}
